export default __webpack_public_path__ + "static/media/deauville02.b0e67c70.jpg";